import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PopoverInput } from '../base/popover-input';

import { SupportDataService, SupplierService } from '../../../_services';
import { ISupplier, ITag } from '../../../_entities';

import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';

@Component({
	selector: 'popover-supplier-selector',
	template: require('./popover-supplier-selector.component.html')
})
export class PopoverSupplierSelectorComponent extends PopoverInput implements OnInit {

	@Input() tagFilter: string;


	foundTagforFilter: ITag;

	items: TreeviewItem[];

	ngOnInit() {

	}

	@ViewChild('treeview') treeView;

	config = TreeviewConfig.create({
		hasFilter: true,
		hasAllCheckBox: false,
		hasCollapseExpand: false,
		decoupleChildFromParent: false,
		maxHeight: 260
	});

	@Input() allowAdd: boolean = true;

	suppliers: ISupplier[] = null;

	select(value: TreeviewItem, event: any) {
		//not sure why this is needed..
		event.preventDefault();
		event.stopPropagation();


		this.newSupplier = "";

		if (this.dirtyValue === value.value) {
			this.dirtyValue = null;
		} else {
			this.dirtyValue = value.value;
		}
	}

	industryTags: ITag[];

	addNewItem: ISupplier = <ISupplier>{ id: 0, companyName: "Add new..." };
	newSupplier: string;

	newSupplierOrgNbr: string;
	newSupplierBankInfo: string;

	newSupplierAddress1: string;
	newSupplierAddress2: string;
	newSupplierPostalCode: string;
	newSupplierCity: string;
	newSupplierCountry:  string = "SE";

	newSupplierFirstName: string;
	newSupplierLastName: string;
	newSupplierPhone: string;
	newSupplierMobilePhone: string;
	newSupplierEmail: string;
	newSupplierRole: string;


	validationMsg: string;

	constructor(private supplierService: SupplierService, private supportData: SupportDataService, private elementRef: ElementRef) {
		super();

		this.refreshData();
	}


	async onShow() {
		super.onShow();
		console.log("on-show");
		this.warning = "";
		this.treeView.filterText = "";
		await this.refreshData();


		try {
			const selected = document.getElementById('selected-supplier');
			selected.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
		} catch (e) {
		}
	}

	onNewSupplierTextChange() {
		if (!!this.newSupplier) {
			this.dirtyValue = 0;
			this.config.maxHeight = 0;
		} else {
			this.config.maxHeight = 260;
			this.dirtyValue = this.originalValue;
		}
	}

	async onPreSave($event) {

		this.validationMsg = "";

		//add new item before saving
		if (this.newSupplier) {
			const supplier: any = {
				companyName: this.newSupplier,
				organizationNumber: this.newSupplierOrgNbr,
				bankInformation: this.newSupplierBankInfo,

				//contact: [
				//	{
				//		firstName: this.newSupplierFirstName,
				//		lastName: this.newSupplierLastName,
				//		phoneNumber: this.newSupplierPhone,
				//		mobileNumber: this.newSupplierMobilePhone,
				//		role: this.newSupplierRole,
				//		email: this.newSupplierEmail
				//	}],

				supplierAddress: [{
					address1: this.newSupplierAddress1,
					address2: this.newSupplierAddress2,
					postalCode: this.newSupplierPostalCode,
					city: this.newSupplierCity,
					country: this.newSupplierCountry,
					addressTypeId: 1
				}]

		};

			console.log("onPreSave");

			console.dir(supplier);

			if (!!this.foundTagforFilter) {
				supplier.industryTags = [this.foundTagforFilter.id];
			}

			try {
				var createdSupplier = await this.supplierService.addItem(supplier);
				//this.suppliers.push(<ISupplier>{ id: createdSupplier.id, companyName: createdSupplier.companyName });

				this.dirtyValue = createdSupplier.id;

				this.onSave($event);

				this.refreshData();

				this.clearNewSupplier();

			} catch (e) {
				$event.reject();

				if (e.statusCode == 409) {
					this.warning = "This supplier already exists";
				} else {
					this.warning = "Could not save this supplier";
				}

			
			}

		}
		else if (this.dirtyValue !== 0) {
			this.onSave($event);
		} else {
			$event.reject();
			this.validationMsg = "Please enter supplier name";
		}

	}

	get displayText() {

		if (this.suppliers) {
			const item = this.suppliers.find(x => x.id == this.originalValue);

			if (item)
				return item.companyName;

			if (this.originalValue && item == null)
				return "!! " + this.originalValue;
		}


		return "";
	}



	get tooltip() {

		if (this.suppliers) {
			const item = this.suppliers.find(x => x.id == this.originalValue);

			if (item)
				return `OrgNr: ${item.organizationNumber}`;
		}


		return "";
	}

	get info() {

		if (this.suppliers && this.originalValue) {
			const item = this.suppliers.find(x => x.id == this.originalValue);

			let info = [
				{
					key: "info",
					value: `orgnbr: ${item.organizationNumber || "not entered"}, bank: ${item.bankInformation || "not entered"}`
				}
			];

			let contacts = ((<any>item).contact || []).map(x => ({
				key: `${x.name}, ${x.role || '?'}`,
				value: `m: ${x.mobileNumber || "not entered"}, e: ${x.email || "not entered"}`
			}));


			return {
				title: "Info & Contacts",
				data: info.concat(contacts)
			}
		}

		return null;

	}


	warning: string;

	async refreshData(): Promise<void> {

		return this.supplierService.getItems().then(result => {

			this.supportData.getIndustryTags().then(x => {
				this.industryTags = x;

				this.foundTagforFilter = this.industryTags.find(x => x.name.toLowerCase() === (this.tagFilter + "").toLowerCase());

				this.suppliers = result.filter(x => x.companyName !== "").sort((a, b) => a.name.localeCompare(b.name));

				var matchingSuppliers = this.suppliers.filter(x => x.industryTags.some(y => !!this.foundTagforFilter && y === this.foundTagforFilter.id))
					.map(x => ({ text: x.companyName, value: x.id }));

				if (!!this.tagFilter && !this.foundTagforFilter) {
					this.warning = "Tag '" + this.tagFilter + "' does not exist.";
				}

				else if (!!this.foundTagforFilter && matchingSuppliers.length === 0) {
					this.warning = "No suppliers matches '" + this.tagFilter + "'";
				}

				var notMatchingSuppliers = this.suppliers.filter(x => !x.industryTags.some(y => !!this.foundTagforFilter && y === this.foundTagforFilter.id))
					.map(x => ({ text: x.companyName, value: x.id }));


				if (!!this.tagFilter && matchingSuppliers.length > 0) {
					this.items = [
						new TreeviewItem(
							{
								text: 'Matching Tag ' + this.tagFilter,
								collapsed: false,
								value: { isOpen: true },
								children: matchingSuppliers
							}), new TreeviewItem(
								{
									text: 'Other',
									collapsed: false,
									value: { isOpen: true },
									children: notMatchingSuppliers
								})
					];
				} else {
					this.items = [
						new TreeviewItem(
							{
								text: 'All Suppliers',
								collapsed: false,
								value: { isOpen: true },
								children: notMatchingSuppliers
							}
						)
					];
				}



			});
		});

		

	}

	clearNewSupplier() {
		this.newSupplier = "";
		this.newSupplierBankInfo = "";
		this.newSupplierOrgNbr = "";

		this.newSupplierAddress1 = "";
		this.newSupplierAddress2 = "";
		this.newSupplierCity = "";
		this.newSupplierPostalCode = "";
		this.newSupplierCountry = "SE";

		this.newSupplierFirstName = "";
		this.newSupplierLastName = "";
		this.newSupplierPhone = "";
		this.newSupplierMobilePhone = "";
		this.newSupplierEmail = "";
		this.newSupplierRole = "";

	}

	cancel() {
		this.config.maxHeight = 260;
		this.clearNewSupplier();
		this.onCancel();
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/popover-supplier-selector.component.ts